export default {
  stateKey: 'profile',
  uuid: 'uuid',
  editable: {
    profile: 'editable.profile',
    settings: 'editable.settings',
    notifications: 'editable.notifications'
  },
  tab: {
    current: 'tab.current',
    defaultProjects: 'TabProjectBoards',
    defaultStories: 'TabStoryBoards',
    defaultCantPublish: 'TabContributions',
    manageClassTab: 'TabMyClasses'
  },
  importData: 'import.data',
  callbacks: {
    save: {
      profile: 'save.profile',
      skills: 'save.skills',
      interests: 'save.interests',
      user: 'save.user',
      settings: 'save.settings',
      notifications: 'save.notifications'
    },
    linkedIn: {
      auth: 'linkedin.auth',
      import: 'linkedin.import'
    }
  },
  editingCount: 'editingCount'
}
